export const fixSafariScrolling = (el: HTMLElement) => {
    el.addEventListener('webkitAnimationEnd', (e: any) => {
        e.target.style.overflowY = 'hidden';
        setTimeout(function () { e.target.style.overflowY = 'auto'; });
    });
}
